import { Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE } from "../config/site";

const NOTES = [
    "Prima lezione gratuita: se non fa per te, non paghi nulla",
    "Stessa tariffa per medie e superiori",
    "Online o a domicilio, il prezzo non cambia",
    "Nessun pacchetto obbligatorio: paghi le lezioni che fai",
];

const Pricing = () => (
    <section id="prezzi" className="relative py-32 sm:py-40 border-t border-slate-800 overflow-hidden">
        <div className="absolute inset-0 graph-paper opacity-60" aria-hidden="true" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,#020617_80%)]" aria-hidden="true" />

        <div className="relative z-10 max-w-[1440px] mx-auto px-6 sm:px-10">
            <Reveal>
                <p className="font-mono text-xs uppercase tracking-[0.35em] text-sky-400">04 · Prezzi</p>
                <h2 className="mt-6 font-serif text-4xl sm:text-5xl text-slate-50 tracking-tight">
                    Una tariffa sola. <em className="text-sky-400">Chiara.</em>
                </h2>
            </Reveal>

            <div className="mt-16 grid lg:grid-cols-2 gap-16 items-end">
                <Reveal delay={0.1}>
                    <div data-testid="price-display" className="flex items-baseline gap-4">
                        <span className="font-mono text-[7rem] sm:text-[11rem] leading-none text-slate-50 tracking-tighter">
                            {SITE.price}€
                        </span>
                        <span className="font-mono text-2xl text-slate-500">/ora</span>
                    </div>
                    <p className="mt-6 max-w-md text-slate-300 leading-relaxed">
                        Niente listini nascosti, niente "dipende". Ti diciamo il prezzo prima
                        di cominciare e quello resta.
                    </p>
                </Reveal>

                <Reveal delay={0.2}>
                    <ul className="space-y-0 border-t border-slate-800">
                        {NOTES.map((note, i) => (
                            <li
                                key={i}
                                data-testid={`price-note-${i}`}
                                className="flex items-center gap-4 border-b border-slate-800 py-5 text-slate-300"
                            >
                                <span className="font-mono text-sky-400 text-sm">0{i + 1}</span>
                                {note}
                            </li>
                        ))}
                    </ul>
                    <a
                        data-testid="pricing-call-button"
                        href={SITE.tutors[0].phoneHref}
                        className="mt-10 inline-flex items-center gap-3 bg-slate-50 text-[#020617] font-semibold px-8 py-4 hover:bg-sky-400 transition-colors duration-300"
                    >
                        <Phone size={18} /> Prenota la lezione gratuita
                    </a>
                </Reveal>
            </div>
        </div>
    </section>
);
export default Pricing;
